import * as React from 'react';
import { classes, st } from './SubtotalRow.st.css';
import { Text } from 'wix-ui-tpa/Text';
import { TotalsDataHook } from '../../Totals';
export var SubtotalRow = function (_a) {
    var title = _a.title, value = _a.value, className = _a.className;
    return (React.createElement("tr", { "data-hook": TotalsDataHook.SubtotalsRow, className: st(classes.root, className) },
        React.createElement("td", { className: classes.labelTextAlign },
            React.createElement(Text, { className: classes.subTotalTitleText, "data-hook": TotalsDataHook.SubtotalsRowTitle }, title)),
        React.createElement("td", { className: classes.textAlign },
            React.createElement(Text, { className: classes.subTotalTitleValue, "data-hook": TotalsDataHook.SubtotalsRowValue }, value))));
};
SubtotalRow.displayName = 'Totals.SubtotalRow';
//# sourceMappingURL=SubtotalRow.js.map